const createElementToast = {
	el: {
		body: document.body,
		toastSubmit: document.querySelectorAll('.js-toast-submit')
	},

	fxCreateToastMainContainerOnDOM() {
		// check if DOM already have parent container for toasts
		if (!document.querySelector('.toast')) {
			const newToastContainer = '<div class="toast"></div>'
			this.el.body.insertAdjacentHTML('beforeend', newToastContainer)
		}
	},

	fxCreateToastItem(type, copy) {
		// call function that sets parent container
		this.fxCreateToastMainContainerOnDOM()

		// save variable let (let it change)
		let iconType

		// condition for which type of icon will be placed inside toast
		switch (type) {
			case 'success':
				iconType = `
						<?xml version="1.0" encoding="UTF-8"?>
						<svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.7">
								<g transform="translate(-124.000000, -268.000000)" fill="#FFFFFF">
									<g transform="translate(106.000000, 235.000000)">
										<path d="M41,45.5 C41,39.701375 36.298625,35 30.5,35 C24.701375,35 20,39.701375 20,45.5 C20,51.298625 24.701375,56 30.5,56 C36.298625,56 41,51.298625 41,45.5 M43,45.5 C43,52.4035714 37.4035714,58 30.5,58 C23.5964286,58 18,52.4035714 18,45.5 C18,38.5964286 23.5964286,33 30.5,33 C37.4035714,33 43,38.5964286 43,45.5 M35.7445658,40.2688416 C36.0829753,40.622288 36.0855652,41.1974334 35.7497455,41.5536056 C35.7480189,41.5554228 35.7462924,41.55724 35.7445658,41.5590572 L27.9749592,49.7364798 C27.8117975,49.9063884 27.5916586,50.0017917 27.3620236,50 L27.3102262,50 C27.0659152,49.9827111 26.8397333,49.8573239 26.6886577,49.6547056 L23.2354992,45.111693 C22.9083124,44.7464348 22.9238516,44.1712894 23.270894,43.826929 C23.6170732,43.4825687 24.1635355,43.4998321 24.4907223,43.8641817 C24.5243906,43.9014344 24.555469,43.9423216 24.582231,43.9850259 L27.4310867,47.7284682 L34.5186945,40.2688416 C34.8545142,39.9126694 35.4009765,39.9099436 35.7393861,40.26339 C35.7411126,40.2652072 35.7428392,40.2670244 35.7445658,40.2688416"></path>
									</g>
								</g>
							</g>
						</svg>
					`
				break
			case 'warning':
				iconType = `
						<?xml version="1.0" encoding="UTF-8"?>
						<svg width="28px" height="25px" viewBox="0 0 28 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.7">
								<g transform="translate(-962.000000, -268.000000)" fill="#FFFFFF">
									<g transform="translate(946.000000, 235.000000)">
										<path d="M29.999875,51.9188883 C29.2635504,51.9188883 28.6665576,52.5239549 28.6665576,53.2702375 C28.6665576,54.0165201 29.2635504,54.6215867 29.999875,54.6215867 C30.7361996,54.6215867 31.3331925,54.0165201 31.3331925,53.2702375 C31.3331925,52.5239549 30.7361996,51.9188883 29.999875,51.9188883 L29.999875,51.9188883 Z M29.999875,40.4324204 C29.4475482,40.4324204 28.9998869,40.8861359 28.9998869,41.4459323 L28.9998869,49.5540273 C28.9998869,50.1138237 29.4475482,50.5675392 29.999875,50.5675392 C30.5522018,50.5675392 30.9998631,50.1138237 30.9998631,49.5540273 L30.9998631,41.4459323 C30.9998631,40.8861359 30.5522018,40.4324204 29.999875,40.4324204 L29.999875,40.4324204 Z M29.999875,35.0270237 C30.1308734,35.0270237 30.3238711,35.1422263 30.3852037,35.248645 L41.9373995,55.318545 C41.9983987,55.4249637 41.9987321,55.644558 41.9373995,55.7513146 C41.9043999,55.8080712 41.6307365,55.9732737 41.499738,55.9729366 L18.4480126,55.9729366 C18.3166808,55.9732737 18.1240165,55.8577333 18.0623505,55.7513146 C18.0010179,55.644558 18.0013513,55.4249637 18.0623505,55.318545 L29.6145463,35.248645 C29.6758789,35.1422263 29.8688766,35.0270237 29.999875,35.0270237 L29.999875,35.0270237 Z M29.999875,33 C29.1218855,33 28.3292282,33.454729 27.8852335,34.2246602 L16.3333711,54.2942223 C15.8893764,55.0661805 15.8883764,55.9935439 16.3333711,56.7648264 C16.7786992,57.536109 17.5680231,58.0023244 18.4480126,57.9999799 L41.499738,57.9999799 C42.3797275,58.0033379 43.1923845,57.5857711 43.6663789,56.7648264 C44.1117069,55.9935439 44.1107069,55.0661805 43.6663789,54.2942223 L32.1145165,34.2246602 C31.6705218,33.454729 30.8778645,33 29.999875,33 Z"></path>
									</g>
								</g>
							</g>
						</svg>
					`
				break

			case 'danger':
				iconType = `
						<?xml version="1.0" encoding="UTF-8"?>
						<svg width="27px" height="25px" viewBox="0 0 27 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
						
							<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.7">
								<g transform="translate(-543.000000, -268.000000)" fill="#FFFFFF">
									<g transform="translate(526.000000, 235.000000)">
										<g transform="translate(17.500000, 33.000000)">
											<path d="M13,23.0769231 C7.15865385,23.0769231 2.42307692,18.3413462 2.42307692,12.5 C2.42307692,6.65865385 7.15865385,1.92307692 13,1.92307692 C18.8413462,1.92307692 23.5769231,6.65865385 23.5769231,12.5 C23.5769231,18.3413462 18.8413462,23.0769231 13,23.0769231 M13,0 C6.09615385,0 0.5,5.59615385 0.5,12.5 C0.5,19.4038462 6.09615385,25 13,25 C19.9038462,25 25.5,19.4038462 25.5,12.5 C25.5,5.59615385 19.9038462,0 13,0"></path>
											<path d="M17.210991,8.28900905 C16.8236592,7.90366365 16.1979695,7.90366365 15.8106378,8.28900905 L13,11.0996469 L10.1893622,8.28900905 C9.77322887,7.93246524 9.14555286,7.98112999 8.78900905,8.3972633 C8.47020525,8.76870448 8.47020525,9.31792099 8.78900905,9.68936217 L11.5996469,12.5 L8.78900905,15.3106378 C8.40366365,15.6979695 8.40366365,16.3236592 8.78900905,16.710991 C9.17634076,17.0963363 9.80203046,17.0963363 10.1893622,16.710991 L13,13.9003531 L15.8106378,16.710991 C16.1979695,17.0963363 16.8236592,17.0963363 17.210991,16.710991 C17.5963363,16.3236592 17.5963363,15.6979695 17.210991,15.3106378 L14.4003531,12.5 L17.210991,9.68936217 C17.5963363,9.30203046 17.5963363,8.67634076 17.210991,8.28900905"></path>
										</g>
									</g>
								</g>
							</g>
						</svg>
					`
				break

			default:
				iconType = `
					<?xml version="1.0" encoding="UTF-8"?>
					<svg width="25px" height="25px" viewBox="0 0 25 25" version="1.1" xmlns="http://www.w3.org/2000/svg">
						<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.7">
							<g transform="translate(-124.000000, -268.000000)" fill="#FFFFFF">
								<g transform="translate(106.000000, 235.000000)">
									<path d="M41,45.5 C41,39.701375 36.298625,35 30.5,35 C24.701375,35 20,39.701375 20,45.5 C20,51.298625 24.701375,56 30.5,56 C36.298625,56 41,51.298625 41,45.5 M43,45.5 C43,52.4035714 37.4035714,58 30.5,58 C23.5964286,58 18,52.4035714 18,45.5 C18,38.5964286 23.5964286,33 30.5,33 C37.4035714,33 43,38.5964286 43,45.5 M35.7445658,40.2688416 C36.0829753,40.622288 36.0855652,41.1974334 35.7497455,41.5536056 C35.7480189,41.5554228 35.7462924,41.55724 35.7445658,41.5590572 L27.9749592,49.7364798 C27.8117975,49.9063884 27.5916586,50.0017917 27.3620236,50 L27.3102262,50 C27.0659152,49.9827111 26.8397333,49.8573239 26.6886577,49.6547056 L23.2354992,45.111693 C22.9083124,44.7464348 22.9238516,44.1712894 23.270894,43.826929 C23.6170732,43.4825687 24.1635355,43.4998321 24.4907223,43.8641817 C24.5243906,43.9014344 24.555469,43.9423216 24.582231,43.9850259 L27.4310867,47.7284682 L34.5186945,40.2688416 C34.8545142,39.9126694 35.4009765,39.9099436 35.7393861,40.26339 C35.7411126,40.2652072 35.7428392,40.2670244 35.7445658,40.2688416"></path>
								</g>
							</g>
						</g>
					</svg>
				`
				break
		}

		// Creating toast message container as dom element
		const toastItemElement = document.createElement('div')

		// Add toast__item class to it
		toastItemElement.classList.add('toast__item')

		// If there is a type, add that type as class
		type && toastItemElement.classList.add(type)

		// Everything that goes inside each toast item
		const toastContent = `
			<div class="toast__icon"> 
				${iconType}
			</div>
			<div class="toast__copy">
				${copy}
			</div>
		`

		// insert the rest of toas inside toast item element
		toastItemElement.insertAdjacentHTML('beforeend', toastContent)

		// append each toast to parent container toast
		document.querySelector('.toast').appendChild(toastItemElement)

		// insert active class for animation
		setTimeout(() => toastItemElement.classList.add('active'), 100)

		// remove active class and container
		setTimeout(() => {
			toastItemElement.classList.remove('active')
			setTimeout(() => toastItemElement.remove(), 500)
		}, 3000)
	},

	fxCallToast(el) {
		// prevent default if is a link calling toast
		el.preventDefault()

		// get data atribute data-toast-type on target
		const toastType = el.currentTarget.dataset.toastType

		// get data atribute data-toast-copy on target
		const toastCopy = el.currentTarget.dataset.toastCopy

		this.fxCreateToastItem(toastType, toastCopy)
	},

	events() {
		// in case we want toast once click on button or link
		this.el.toastSubmit.forEach(el => el.addEventListener('click', e => this.fxCallToast(e)))
	},

	init() {
		this.events()
	}
}

createElementToast.init()